import { useMemo } from "react"

import { useSubTeams } from "@/hooks/useSubTeams"

export interface FilterOption {
  value: string
  label: string
}

/**
 * Hook to get filter options for compliance components
 * Centralizes the logic for driver manager teams and DSP options
 */
export function useComplianceFilterOptions() {
  const { subTeamOptionsWithIds } = useSubTeams()

  const driverManagerTeamOptions = useMemo<FilterOption[]>(() => {
    return subTeamOptionsWithIds
      .filter((option) => option.type === "DRIVER_MANAGER_TEAM")
      .map((option) => ({ value: option.id, label: option.label }))
  }, [subTeamOptionsWithIds])

  const dspOptions = useMemo<FilterOption[]>(() => {
    return subTeamOptionsWithIds
      .filter((option) => option.type === "DSP")
      .map((option) => ({ value: option.id, label: option.label }))
  }, [subTeamOptionsWithIds])

  return {
    driverManagerTeamOptions,
    dspOptions,
  }
}
